export enum StepState {
    done = 'done',
    current = 'current',
    edit = 'edit',
    remainingWithData = 'remainingWithData',
    remaining = 'remaining',
}
